import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Cart from "./components/cart";
import Products from "./components/Products";
import store from "./Redux/store";

function App() {
 return (
  <Provider store={store}>
   <BrowserRouter>
    <Routes>
     <Route path="/" element={<Products />} />
     <Route path="/cart" element={<Cart />} />
    </Routes>
   </BrowserRouter>
  </Provider>
 );
}

export default App;
